import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { showLoading, hideLoading } from "@/utils/loading";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout 这边设置为10秒
});

service.defaults.headers = {
  "Content-Type": "application/json; text/plain; charset=utf-8"
  // 'Authorization': 'TBOX c5826f240527d84c3cad8f046d6d611c'
  // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  // 'Content-Type': 'text/plain;'
};
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // showLoading()

    if (config.method == "get") {
      config.data = config["params"] = config.data;
      if (config["params"]) {
        config["params"]["_"] = Date.parse(new Date()) / 1000; //添加时间
      }
    }

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = "TBOX " + getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    // hideLoading();
    if (res.code != 20000) {
      // 没有权限
      if (res.code == 90001) {
        Message({
          message: res.message || "没有操作权限",
          type: "warning",
          duration: 5 * 1000
        });
      } else {
        Message({
          message: res.message || "Error",
          type: "error",
          duration: 5 * 1000
        });
      }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code == 50008 || res.code == 50012 || res.code == 50014) {
        // to re-login
        if (res.code == 50008 || res.code == 50012) {
          MessageBox.confirm("登录失败，请检查用户名密码", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            store.dispatch("user/resetToken").then(() => {
              location.reload();
            });
          });
        } else if (res.code == 50014) {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        }
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    // hideLoading();
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
